import React from "react";
import { Link } from "react-router-dom";

import ThemeTogglerTwo from "../../components/common/common/ThemeTogglerTwo";
import { CaseKeepLogo } from "../../components/common/CaseKeepLogo/CaseKeepLogo";
import LockVault from "../../images/lock-vault.webp";

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="relative bg-white z-1 dark:bg-gray-900">
      {/* Header with logo */}
      <header className="absolute top-0 left-0 right-0 z-10 p-4 sm:p-6">
        <Link to="/" className="inline-flex items-end">
          <CaseKeepLogo className="dark:fill-white h-8 w-auto mr-2" />
          <span className="text-gray-900 dark:text-white text-lg">
            Case<span className="font-bold">keep</span>
          </span>
        </Link>
      </header>

      <div className="relative flex flex-col justify-center w-full min-h-screen lg:flex-row dark:bg-gray-900 p-6 sm:p-0">
        {children}
        <div
          className="items-center hidden w-full lg:w-1/2 bg-brand-950 dark:bg-white/5 lg:flex self-stretch"
          style={{
            backgroundImage: `url(${LockVault})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="fixed z-50 hidden bottom-6 right-6 sm:block">
          <ThemeTogglerTwo />
        </div>
      </div>
    </div>
  );
}
